/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import React, { useState, useContext, useMemo, useEffect } from 'react'
import moment from 'moment'
import {
  unitIdHeader,
  modifierCol,
  modifiedDateCol,
} from 'core/HeaderColTypeProps'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import {
  retrieveStartupCost,
  deleteStartupCost,
  saveStartupCost,
  nrgProcessMarginStartupHeatCost,
} from 'api/pgads'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getClientInfo,
  getEnvConfig,
  getPermitActions,
  getUnits,
  hasAccesPermits,
} from 'core'
import { CriteriaRow } from 'core/screen-util'
import { Button, DatePicker, InputNumber, message, Select } from 'antd'
import { ErrorContext, PNodeZoneContext, SpinContext } from 'context'
import * as Actions from 'core/EventActions'

import CommonScreen from 'admin/component/CommonScreen'

import { toSelectionColProps } from '@integec/grid-tools'

import MarginAnalysisUtilityUnitSelection from './../MarginAnalysisUtilityUnitSelection'
import { getStartFuelCodeAtStartupCostByClients } from 'marginanalysis/utils'
import { NRG_CLIENT, WEE_CLIENT } from 'client'

const Label = styled.div`
  display: grid;
  justify-content: end;
  align-content: center;
`

const headers = [
  //   strCol({ ident: 'unitid', display: 'Unitid', isKey: true, sortOrder: 'asc' }),
  unitIdHeader,
  dateCol({
    ident: 'effectivedate',
    display: 'Effective Date',
    isKey: true,
    sortOrder: 'desc',
    width: 150,
  }),
  strCol({
    ident: 'startFuelCode',
    display: 'Start Fuel Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(StartupCostChioce),
  }),
  numCol({
    ident: 'hotStartupCost',
    display: 'Hot Startup',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'interStartupCost',
    display: 'Inter Startup',
    isFiltered: true,
    displayFormat: '0.00000',
    sortOrder: 'asc',
    width: 150,
  }),
  numCol({
    ident: 'coldStartupCost',
    display: 'Cold Startup',
    isFiltered: true,
    displayFormat: '0.000000',
    sortOrder: 'asc',
    width: 150,
  }),
  modifierCol,
  modifiedDateCol,
]

const StartupCost = ({ targetInfo, envConfig, actionPermits, CLIENT }) => {
  // const { selectedUnits } = useContext(UnitSelectionContext)

  const title = CLIENT === WEE_CLIENT ? 'Startup Heat' : 'Startup Heat Cost'

  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const [insertEvent, setInsertEvent] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [editMode, setEditMode] = useState(true)

  const [startFuelCodeMap, setStartFuelCodeMap] = useState({})
  const [selectedDateRangePicker, setSelectedDateRagePicker] = useState([
    moment()
      .subtract(1, 'month')
      .startOf('month'),
    moment(),
  ])

  const { unitIdEmktIdMap, marginUnitsList, emktIdUnitNameMap } = useContext(
    PNodeZoneContext
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <CriteriaRow>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '120px 150px 120px 150px 120px 150px 120px 180px',
          gridGap: '5px',
        }}
      >
        <Label>Unit:</Label>
        <div style={{ gridColumn: 'span 3' }}>
          <MarginAnalysisUtilityUnitSelection
            utility={insertData.utility || null}
            unit={insertData.unit || null}
            onUnitChange={value => {
              // setUtilityUnit(value)
              setInsertData({
                ...insertData,
                utility: value[0],
                unit: value[1],
                unitId: unitIdEmktIdMap[value[1]],
              })
            }}
            style={{ width: '100%' }}
            showX2X3
          />
        </div>
        <Label>Effective Date:</Label>
        <DatePicker
          allowClear={false}
          format="MM/DD/YYYY"
          value={insertData.effectivedateObj}
          onChange={date => {
            setInsertData({
              ...insertData,
              effectivedate: date.format('YYYY-MM-DD'),
              effectivedateObj: date,
            })
          }}
          style={{ width: '100%' }}
        />
        <Label>Start Fuel Code :</Label>
        <Select
          value={insertData.startFuelCode}
          onChange={value =>
            setInsertData({ ...insertData, startFuelCode: value })
          }
          style={{ width: '100%' }}
        >
          {Object.keys(startFuelCodeMap).map(m => (
            <Select.Option key={m} value={m}>
              {m === startFuelCodeMap[m] ? m : m + ' - ' + startFuelCodeMap[m]}
            </Select.Option>
          ))}
        </Select>
        <Label>Hot Startup Cost:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.hotStartupCost}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, hotStartupCost: value })
          }
        />
        <Label>Inter Startup Cost:</Label>
        <InputNumber
          style={{ width: '100%' }}
          defaultValue={0}
          value={insertData.interStartupCost}
          onChange={value =>
            setInsertData({ ...insertData, interStartupCost: value })
          }
        />
        <Label>Cold Startup Cost:</Label>
        <InputNumber
          style={{ width: '100%' }}
          value={insertData.coldStartupCost}
          defaultValue={0}
          onChange={value =>
            setInsertData({ ...insertData, coldStartupCost: value })
          }
        />
        <div
          style={{
            gridColumn: 'span 2',
            gridRowGap: '10px',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: 'auto auto auto',
            paddingLeft: '5px',
            gridColumnGap: '10px',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </CriteriaRow>
  )

  useEffect(
    _ => {
      getStartFuelCodeAtStartupCostByClients({
        targetInfo,
        setError,
        setStartFuelCodeMap,
        CLIENT: envConfig.clientId,
      })
    },
    [envConfig.clientId, setError, targetInfo]
  )

  const headerWithFormatter = headers.map(header =>
    header.ident === 'unitId' || header.ident === 'unitid'
      ? {
          ...header,
          dataFormatter: ({ value }) => emktIdUnitNameMap[value] || value,
          sortIndexGetter: ({ rowData }) =>
            emktIdUnitNameMap[rowData.unitId] ||
            emktIdUnitNameMap[rowData.unitid] ||
            rowData.unitId ||
            rowData.unitid,
        }
      : header.ident === 'startFuelCode'
      ? {
          ...header,
          ...toSelectionColProps(startFuelCodeMap),
          dataFormatter: ({ value }) =>
            value + '-' + startFuelCodeMap[value] || value,
          dataGetter: ({ rowData }) => rowData.startFuelCode,
        }
      : header
  )

  const writeEventActionPermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [
          Actions.MARGIN_ANALYSIS_ADMIN,
          Actions.MARGIN_ANALYSIS_CORE_WRITE,
        ],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const writePermission = useMemo(_ => writeEventActionPermission && editMode, [
    writeEventActionPermission,
    editMode,
  ])

  const screenCriteria = (s, p, u, onChange) => {
    return (
      <DatePicker.RangePicker
        style={{ marginLeft: '15px' }}
        allowClear={false}
        format="MM/DD/YYYY"
        value={selectedDateRangePicker}
        onChange={d => {
          setSelectedDateRagePicker(d)
          onChange()
        }}
      />
    )
  }

  const withCriteria = (state, props, selectedUnits) => ({
    startDate: selectedDateRangePicker[0],
    endDate: selectedDateRangePicker[1],
    units: (selectedUnits || [])
      .filter(e => !!e)
      .map(e => unitIdEmktIdMap[e.unitId]),
  })

  // writeEventActionPermission ? (
  //   <Checkbox
  //     css={{ marginLeft: '10px', minWidth: '100px' }}
  //     onChange={e => setEditMode(e.target.checked)}
  //     checked={editMode}
  //   >
  //     Edit Mode
  //   </Checkbox>
  // ) : (
  //   <div />
  // )

  const extraUnitSelectionProps = _ => ({
    limitedUnits: marginUnitsList,
    units: marginUnitsList,
    // itemToLabel: e => e.emktId,
  })

  // const modifySaveDataBeforeSave = (saveData, validateData) => {
  //   return saveData.map(s => ({ ...s, unitId: emktUnitMap[s.unitId] }))
  // }

  // eslint-disable-next-line no-unused-vars
  const isEditableGrid = ({ header, rowData }) => {
    if (
      header.ident === 'modifier' ||
      header.ident === 'modifiedDate' ||
      header.isKey
    )
      return false

    return writePermission
  }
  const startOfMonth = momentDate => momentDate.startOf('month')

  const [
    selectedDateRangePickerProcess,
    setSelectedDateRagePickerProcess,
  ] = useState([
    startOfMonth(moment().subtract(1, 'month')),
    startOfMonth(moment()),
  ])
  const extraCriteriaAfterButton = ({ selectedUnits }) => {
    if (writePermission && CLIENT === NRG_CLIENT) {
      const onclick = _ => {
        if (selectedUnits.length === 0) {
          message.error('Please select at least one unit.')
          return
        }
        const units = (selectedUnits || [])
          .filter(e => !!e)
          .map(e => unitIdEmktIdMap[e.unitId])

        // const cretria = withCriteria(_, _, selectedUnits)
        nrgProcessMarginStartupHeatCost(targetInfo, {
          units,
          startDate: selectedDateRangePickerProcess[0],
          endDate: selectedDateRangePickerProcess[1],
        }).fork(setError, _ => {
          setSpinning(false)
          message.success(
            'Process completed successfully.Please retrieve data to see the updated startup heat cost.'
          )
        })
      }

      return (
        // <CriteriaRow style={{ marginTop: '10px', padding: '5px' }}>
        <div
          style={{
            border: '1px dashed gray',
            display: 'grid',
            gridTemplateColumns: '220px auto',
            padding: '2px',
            marginLeft: '10px',
            marginRight: '10px',
            gap: '5px',
          }}
        >
          <DatePicker.RangePicker
            style={{ marginLeft: '15px' }}
            allowClear={false}
            format="MMM/YYYY"
            mode={['month', 'month']}
            placeholder={['Start month', 'End month']}
            value={selectedDateRangePickerProcess}
            onChange={d => {
              setSelectedDateRagePickerProcess([
                startOfMonth(d[0]),
                startOfMonth(d[1]),
              ])
            }}
            onPanelChange={d => {
              setSelectedDateRagePickerProcess([
                startOfMonth(d[0]),
                startOfMonth(d[1]),
              ])
            }}
            // size="small"
          />
          <Button type="danger" onClick={onclick} loading={spinning}>
            Process Startup Heat
          </Button>
        </div>
        // </CriteriaRow>
      )
    } else return <div />
  }

  return (
    <CommonScreen
      // modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      withoutModify={!writeEventActionPermission}
      withDelete={!writeEventActionPermission}
      allowInsert={writeEventActionPermission}
      isEditableGrid={isEditableGrid}
      extraUnitSelectionProps={extraUnitSelectionProps}
      withUnitSelection
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      autoRetrieve={false}
      isAdminScreen={false}
      withCriteria={withCriteria}
      screenCriteria={screenCriteria}
      title={title}
      header={headerWithFormatter}
      saveTask={saveStartupCost}
      retrieveTask={retrieveStartupCost}
      // retrieveTask={_ => _ => ({ fork: _ => _ })}
      deleteTask={deleteStartupCost}
      altBy={u => u.unitId}
      sortOptions={headers}
      initialSortOptions={headers}
      widthOffset={50}
      insertComp={insertEvent && insertComp}
      insertCompHeight={120}
      onInsertEvent={b => setInsertEvent(b)}
      withImport
      importUrl="marginanalysisdata-import/generic-import"
      importData={{ importType: 'MA_STARTUP_COST' }}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  units: getUnits(state),
  CLIENT: getClientInfo(state),
})

export default connect(mapStateToProps)(StartupCost)
